"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsRequests = void 0;
const UserRequests_1 = require("./UserRequests");
class DetailsRequests {
    constructor(session, uuid) {
        this.uuid = uuid;
        this.requests = new UserRequests_1.UserRequests(session);
    }
    get() {
        return this.requests.get(this.uuid);
    }
    updateInformation(data) {
        return this.requests.update(this.uuid, {
            user_metadata: data,
        });
    }
}
exports.DetailsRequests = DetailsRequests;
//# sourceMappingURL=DetailsRequests.js.map